module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"hu":{"main":"Éves beszámolók"},"en":{"main":"Annual reports"}}')
  delete Component.options._Ctor
}
